import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { OVERLAY_PERK_DATA, CLAIMABLE_PERK_CRON, SOCKET_URL } from "../constants/urls";
import styled from "styled-components";
import { io } from "socket.io-client";
import social from "../assets/perks/message.svg";
 
import tomato from '../assets/powers/tomato.svg';
import flashbang from '../assets/powers/flash.svg';
import roses from '../assets/powers/roses.svg';
import heart from '../assets/powers/heart.svg';
import govno from '../assets/powers/govno.svg';
import govno_rainbow from '../assets/powers/govno_rainbow.svg';
import { duration } from "@mui/material";
import ReactGA from 'react-ga4';

const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 100vh;
    flex-direction: column;
  }
  @media only screen and (min-device-width: 480px) 
                   and (max-device-width: 920px) 
                   and (orientation: landscape) {

    display: flex;
    height: 100vh;
    flex-direction: column;
}
`;

const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
    height: 100vh;
    opacity: 0.8
    align-items: flex-end;
    
  }
`;


const Title = styled.div`
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: bold;
  font-size: 26px;
  line-height: 90%;
  /* or 27px */

  display: flex;
  align-items: center;
  text-align: center;

  color: #ffffff;

  /* Brainfuck */

  text-shadow: 0px 4px 20px rgba(255, 255, 255, 0.4),
    0px 4px 4px rgba(0, 0, 0, 0.1);
  overflow-wrap: anywhere;
`;

const Price = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  display: flex;
  align-items: center;

  color: #ffffff;
`;

const Subtitle = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  /* identical to box height */

  display: flex;
  align-items: center;

  color: #9c9c9c;
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  /* or 17px */

  display: flex;
  align-items: center;
  text-align: center;

  color: #ffffff;

  /* Brainfuck */

  text-shadow: 0px 4px 20px rgba(255, 255, 255, 0.4),
    0px 4px 4px rgba(0, 0, 0, 0.1);
`;


const Box = styled.div`
  clip-path: polygon(100% 0%, 100% 85%, 92% 100%, 0% 100%, 0% 15%, 8% 0%);
  width: 234px;
  background: #000;
  background: linear-gradient(68.93deg, #7748e5 4.36%, #1c77fa 96.41%);
  background: ${(props) =>
    props.winner
      ? "linear-gradient(180deg, #ffd600 0%, #ff7a00 100%)"
      : " linear-gradient(68.93deg, #7748E5 4.36%, #1C77FA 96.41%)"};
  padding: 4px;
  margin-left: 20px;
  margin-top: 12px;
  position: relative;
  z-index: 10000;
`;

const PurpleBox = styled.div`
  clip-path: polygon(100% 0%, 100% 85%, 92% 100%, 0% 100%, 0% 15%, 8% 0%);
  width: 234px;
  background: #000;
  background: #7c20f9;
  padding: 4px;
  margin-left: 20px;
  margin-top: 12px;
`;

const BoxInner = styled.div`
  width: 100%;
  height: 100%;
  background: ${(props) =>
    props.winner
      ? "rgba(196, 196, 196, 1)"
      : "linear-gradient(180deg, #1024DD 0%, #000855 100%)"};
  clip-path: polygon(100% 0%, 100% 85%, 92% 100%, 0% 100%, 0% 15%, 8% 0%);
  padding: ${(props) => (props.winner ? "0px" : "10px")};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`;

const PurpleBoxInner = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #2b1941 0%, #220647 75.86%);
  clip-path: polygon(100% 0%, 100% 85%, 92% 100%, 0% 100%, 0% 15%, 8% 0%);
  padding: ${(props) => (props.winner ? "0px" : "10px")};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`;

const Text = styled.div`
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  /* or 15px */

  display: flex;
  align-items: center;
  text-align: center;

  color: #ffffff;
`;

const Bidder = styled.div`
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 145%;
  /* identical to box height, or 15px */

  display: flex;
  align-items: center;
  text-align: center;

  color: #ffffff;

  /* Brainfuck */

  text-shadow: 0px 4px 20px rgba(255, 255, 255, 0.4),
    0px 4px 4px rgba(0, 0, 0, 0.1);
`;

const Message = styled.div`
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 145%;
  color: #ffffff;
  text-shadow: 0px 4px 20px rgba(255, 255, 255, 0.4),
    0px 4px 4px rgba(0, 0, 0, 0.1);
`;

const TimerTitle = ({ auctionEndingAt }) => {
  const [timer, setTimer] = useState({});

  useEffect(() => {
    setTimeout(async () => {
      let temp_timer = calculateTimeLeft(auctionEndingAt);
      setTimer(temp_timer);
    }, 1000);
  }, [timer]);

  const calculateTimeLeft = (time) => {
    let difference = new Date(time) - new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
        show: true,
      };
    }

    return timeLeft;
  };

  let timeLeft = timer;
  // console.log(timeLeft)

  return (
    <>
      {timeLeft && timeLeft.show && (
        <Text style={{ paddingLeft: 6 }}>
          <span style={{ color: "#fff", marginRight: 6 }}>
            {timeLeft.minutes}m {timeLeft.seconds}s
          </span>
        </Text>
      )}
    </>
  );
};


const getDeltaPositionOfClone = (clone, vDelta, hDelta) => {
  // Setting position
  let deltaY = 0;
  if(vDelta)
    deltaY = Math.floor(Math.random() * 2);
  let deltaX = 0;
  if(hDelta)
    deltaX = Math.floor(Math.random() * 2);
  
  if(deltaY)
    clone.style.top = `${Math.floor(Math.random() * 100) * deltaY}px`;
  else
    clone.style.top = `-${Math.floor(Math.random() * 100) * deltaY}px`;
  if(deltaX)
    clone.style.left = `${Math.floor(Math.random() * 100) * deltaX}px`;
  else
    clone.style.left = `-${Math.floor(Math.random() * 100) * deltaX}px`;

  return clone;
}


const playVideoOnNode = (clone) => {
  setTimeout(() => {
    clone.volume = 0.80;
    clone.play();
    clone.style.visibility = 'visible';
    clone.onended = () => {
      clone.removeAttribute('src'); // empty source
      clone.load();
      clone.style.visibility = 'hidden';
    }
  }, 1400);
}


const cloneAndPlay = (element_id, vDelta, hDelta) => {
    const node = document.getElementById(element_id);
    console.log(element_id)
    let clone = node.cloneNode(true);
    document.getElementById("parentnode").appendChild(clone);
    clone = getDeltaPositionOfClone(clone, vDelta, hDelta);
    playVideoOnNode(clone)
}


const sendAckOfPowerUsed = async (itemId, itemType) => {
  const data = {
    itemId, itemType
  };
  const response = await fetch(CLAIMABLE_PERK_CRON, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    mode: 'no-cors',
    headers: {
      'Content-Type': 'application/json'
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify(data) // body data type must match "Content-Type" header
  });
  return response.json(); // parses JSON response into native JavaScript objects
};


const playVoice = (message) => {
  setTimeout(() => {
    var msg = new SpeechSynthesisUtterance(message);
    const voices = window.speechSynthesis.getVoices();
    msg.voice = voices[0]; // Selecting Daniel voice
    msg.rate = 0.8;
    window.speechSynthesis.speak(msg);
  }, 12000);  
};


export default function OverlayPowers(props) {
  const [glips, setGlips] = useState({});
  const [showCard, setShowCard] = useState(true);
  const [auctionEndingAt, setAuctionEndingAt] = useState({});
  // const [playVideoFlash, setPlayVideoFlash] = useState(false);
  // const [playVideoTomatoes, setPlayVideoTomatoes] = useState(false);
  // const [playVideoHearts, setPlayVideoHearts] = useState(false);
  // const [playVideoShit, setPlayVideoShit] = useState(false);
  // const [playVideoRShit, setPlayVideoRShit] = useState(false);
  // const [playVideoRoses, setPlayVideoRoses] = useState(false);
  const [overlayText, setOverlayText] = useState('');
  const [showText, setShowText] = useState([]);
  const [showTicker, setShowTicker] = useState(false);
  const [showImage, setShowImage] = useState(false);
  const socketInformation = useRef({});
  const socketInformationDefault = useRef({});

  const [showMessage, setShowMessage] = useState(false);
  const [messageData, setMessageData] = useState({});
  const { username } = useParams();
  const [overlayData, setOverlayData] = useState([]);
  const [messages, setMessages] = useState([]);

  // Setting up GA
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  });

  useEffect(() => {
    if(!showTicker) {
      setTimeout(() => {
        setShowTicker(true);
        ReactGA.event({
          category: 'overlay_page',
          action: 'ticker_show'
        });
      }, 30 * 60 * 1000)
    } else {
      setTimeout(() => {
        setShowTicker(false);
        ReactGA.event({
          category: 'overlay_page',
          action: 'ticker_hide'
        });
      }, 10 * 1000)
    }
  }, [showTicker]);



  useEffect(() => { //createAndShowImage = (image_url, position, duration, message) => {
    console.log('asdfas');
    if(!showImage) {
      console.log('showimage', showImage)
      setTimeout(() => {
        createAndShowImage('https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/test/streamoverlayimage.png', 'top_left', 15, '');
        setShowImage(true);
        ReactGA.event({
          category: 'overlay_page',
          action: 'image_show'
        });
      }, 47 * 60 * 1000);
    // }, 60 * 1000);
      
    } else {
      setTimeout(() => {
        createAndShowImage('https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/test/streamoverlayimage.png', 'top_left', 15, '');
        setShowImage(false);
        ReactGA.event({
          category: 'overlay_page',
          action: 'image_show'
        });
      },  47 * 60 * 1000)
    // },  60 * 1000)
    }
  }, [showImage]);

  const getDeltaForType = (type) => {
    let deltaX, deltaY;
    for(var i = 0; i < overlayData.length; i++) {
      if(overlayData[i].data.type == type) {
        deltaX = overlayData[i].data.deltaX;
        deltaY = overlayData[i].data.deltaY;
      }
    }
    return {deltaX, deltaY};
  }

  const getImageUrl = (type) => {
    let url;
    for(var i = 0; i < overlayData.length; i++) {
      if(overlayData[i].data.type == type) {
        url = overlayData[i].imageUri;
      }
    }
    return url;
  }


  function StreamImageComponent(props) {
    const url = getImageUrl(props.powerType)
    console.log(url)
      return(
          <img style={{marginTop: 4, width: 80, height: 80}} src={url} />
      );
  }

  const createAndShowImage = (image_url, position, duration, message) => {
    var img = document.createElement('img');
    img.src = image_url;
    img.style.position = 'absolute';
    img.style.zIndex = 1000;
    if(position == 'top_left'){
      img.style.top = '40px';
      img.style.left = '40px';
    }

    if(position == 'top_right') {
      img.style.top = '40px';
      img.style.right = '40px';
    }
    if(position == 'bottom_left') {
      img.style.bottom = '40px';
      img.style.left = '40px';
    }
    if(position == 'bottom_right') {
      img.style.bottom = '40px';
      img.style.right = '40px';
    }

    console.log(document.getElementsByTagName("BODY")[0]);
    document.getElementsByTagName("BODY")[0].appendChild(img);
    
    setTimeout(() => {
      img.parentNode.removeChild(img);
    }, duration * 1000);
  }


  useEffect(() => {
    async function fetchMyAPI() {
        // TODO Change endpoint
        let response = await fetch(OVERLAY_PERK_DATA);
        response = await response.json();
        
        if(response.data) {
            console.log(response.data)
            setOverlayData(response.data.perks);
        }
    }
    fetchMyAPI();
  }, []);


  const flashUsername = (text, type, user_message) => {
   
    var ts = new Date().getTime();

    setTimeout(() => {
      // setShowText(true);
      // add with id as timestamp
      const temp = [...showText];
      temp.push({message: text, type: type, id: ts, user_message});
      setShowText([...temp]);
      
      setTimeout(() => {
        let temp1 = [];
        showText.map((item, index) => {
          if(item.id != ts) {
            temp1.push({id: item.id, message: item.message, type: item.type, user_message});           
          }
        });
        setShowText([...temp1]);
        // setShowText(temp1);        
      }, 10000);
    }, 12000);
  };

  const connectSocketDefault = () => {
    const socket = io(SOCKET_URL, {
      // const socket = io('http://localhost:4040/', {
      transports: ["websocket"],
      query: { roomId: `c-overlay` },
    });

    socketInformationDefault.current.socket = socket;
    socket.on("connect", () => {
      console.log("socket establishedgg");      
      socket.on("data", (data) => {        
        console.log(data);
      });
    });

    socket.on("message", (data: any) => {
      console.log("data", data);
      if (data.category == 'config') {
        location.reload(true);
      } 
    });

    socket.on("disconnect", (reason) => {
      console.log(socket.id, reason);
      console.log("disconnect gg");
      socketInformationDefault.current.socket = undefined;
    });
  };

  const connectSocket = (userName) => {
      const socket = io(SOCKET_URL, {
      // const socket = io('http://localhost:4040/', {
      transports: ["websocket"],
      query: { roomId: `c-overlay-${username}` },
    });
    socketInformation.current.username = username;
    socketInformation.current.socket = socket;
    socket.on("connect", () => {
      console.log("socket establishedgg");      
      socket.on("data", (data) => {        
        console.log(data);
      });
    });

    socket.on("message", (data: any) => {
      console.log("data", data);
      if(data.category == 'overlay_power') {
        const {deltaX, deltaY} = getDeltaForType(data.type);
        cloneAndPlay(`playVideo-${data.type}`, deltaY, deltaX) 
        flashUsername(data.data.message, data.type, data.data.bidderMessage);

        // For making sticky messages appear on top
        const temp = [...messages];
        temp.push({message: data.data.bidderMessage, timestamp: new Date(), username: data.data.username});
        setMessages([...temp]);

        // // For tts to play voice messages 
        if(data.data.bidderMessage && data.data.bidderMessage != '') {
          playVoice(`${data.data.username} said ${data.data.bidderMessage}`);
        }
          
        
        // GA event fired
        ReactGA.event({
          category: 'overlay_page',
          action: 'power_triggered',
          power: data.type,
        });

        // Sending ack to server for successful fire of power
        // sendAckOfPowerUsed(data.data.itemId, data.data.itemType);

      } else if (data.category == 'image') {
        console.log('image player triggered', data)
        if(data.type == 'glip_discovery') {

          createAndShowImage(data.data.imageUri,  data.data.position, data.data.duration, data.data.plainMessage);
          
          // GA event fired
          ReactGA.event({
            category: 'overlay_page',
            action: 'image_show',
          });
        }        
      } else if (data.category == 'ticker') {
        console.log('ticker triggered', data)
        if(data.type == 'overlay_power') {

          //Trigger ticker for powers
          let duration = 60;
          if(data.data.duration) duration = data.data.duration;
          if(data.duration) duration = data.duration;

          setShowTicker(true); // Show ticker
          // GA event fired
          ReactGA.event({
            category: 'overlay_page',
            action: 'ticker_show',
          });
          setTimeout(() => {
            setShowTicker(false)
            // GA event fired
            ReactGA.event({
              category: 'overlay_page',
              action: 'ticker_hide',
            });
          }, duration * 1000); //Hide ticker
        }
      }

    });

    socket.on("disconnect", (reason) => {
      console.log(socket.id, reason);
      console.log("disconnect default socket gg");
      socketInformation.current.socket = undefined;
    });
  };

  useEffect(() => {
    connectSocket(username);
    connectSocketDefault();
    return () => {
      if (socketInformation.current.socket) {
        socketInformation.current.socket.disconnect();
        socketInformation.current.socket = undefined;      
        socketInformation.current.username = undefined;
        socketInformationDefault.current.socket = undefined;
      }
    };
  }, []);

  const Card = ({ item }) => {
    console.log(item);

    if (item.type == "onNewTopBid")
      return (
        <Box>
          <BoxInner>
            <div
              style={{
                marginBottom: 18,
                display: "flex",
                justifyContent: "center",
                padding: 4,
                background: "rgba(0,0,0,0.3)",
              }}
            >
              <Text>NFT #{item.payload.serial} · </Text>
              <TimerTitle
                setShowCard={setShowCard}
                auctionEndingAt={auctionEndingAt[item.payload.serial]}
              />
            </div>
            <Title style={{ fontSize: 32 }}>
              {item.payload.bidderUserName}
            </Title>
            <Bidder style={{ marginTop: 10 }}>BID {item.payload.currency == 'USD' ? '$' : '₹'}{item.payload.value}</Bidder>
            <Subtitle style={{ marginTop: 10 }}>!glip IN CHAT</Subtitle>
          </BoxInner>
        </Box>
        // <div style={{opacity: 1, padding: 8, paddingTop: 0, margin: 6, background: 'linear-gradient(98.93deg, rgba(0, 0, 0, 0.2) 43.21%, rgba(0, 0, 0, 0) 99.61%), linear-gradient(0deg, #000000, #000000)'}}>
        //     <div style={{display: 'flex', justifyContent: 'space-between'}}>
        //         <Title style={{paddingTop: 6, paddingBottom: 6}}>NFT #{item.payload.serial}</Title>
        //         <TimerTitle auctionEndingAt={auctionEndingAt[item.payload.serial]} />
        //     </div>

        //     <div style={{display: 'flex', marginTop: 6}}>
        //         <Subtitle style={{marginRight: 8, color: 'grey'}}> @{item.payload.bidderUserName} bid </Subtitle>
        //         <Subtitle style={{color: '#fff'}}>${item.payload.value}</Subtitle>
        //     </div>
        // </div>
      );
    else if (item.type == "onBidWinBroadcast")
      return (
        <Box winner={true}>
          <BoxInner winner={true}>
            <div
              style={{
                width: "100%",
                background: "#413321",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                padding: 10,
              }}
            >
              <div
                style={{
                  marginBottom: 18,
                  display: "flex",
                  justifyContent: "center",
                  padding: 4,
                  background: "rgba(0,0,0,0.3)",
                }}
              >
                <Text>#{item.payload.serial} · AUCTION ENDED</Text>
              </div>
              <Title style={{ fontSize: 32 }}>
                {item.payload.bidderUserName}
              </Title>
              <Bidder style={{ marginTop: 10 }}>WON THE NFT</Bidder>
              <Subtitle style={{ marginTop: 10 }}>!glip IN CHAT</Subtitle>
            </div>
          </BoxInner>
        </Box>
        // <div style={{opacity: 1, padding: 8, paddingTop: 0, margin: 4, background: 'linear-gradient(98.93deg, rgba(0, 0, 0, 0.2) 43.21%, rgba(0, 0, 0, 0) 99.61%), linear-gradient(0deg, #000000, #000000)'}}>
        //     <div style={{}}>
        //         <Title style={{paddingTop: 6, paddingBottom: 6}}>NFT #{item.payload.serial}</Title>
        //     </div>

        //     <div style={{marginTop: 6}}>
        //         <Subtitle>{item.title}</Subtitle>
        //     </div>
        // </div>
      );
    else if (item.type == "onNewAuction")
      return (
        <Box>
          <BoxInner>
            <div
              style={{
                marginBottom: 18,
                display: "flex",
                justifyContent: "center",
                padding: 4,
                background: "rgba(0,0,0,0.3)",
              }}
            >
              <Text>NFT #{item.payload.serial} ·</Text>
              <TimerTitle
                auctionEndingAt={auctionEndingAt[item.payload.serial]}
              />
            </div>
            <Title>LIVE NFT DROPPED</Title>
            <Subtitle style={{ marginTop: 10 }}>!glip IN CHAT</Subtitle>
          </BoxInner>
        </Box>
        // <div style={{opacity: 1, padding: 8, paddingTop: 0, margin: 4, background: 'linear-gradient(98.93deg, rgba(0, 0, 0, 0.2) 43.21%, rgba(0, 0, 0, 0) 99.61%), linear-gradient(0deg, #000000, #000000)'}}>
        //      <div style={{display: 'flex', justifyContent: 'space-between'}}>
        //         <Title style={{paddingTop: 6, paddingBottom: 6}}>NFT #{item.payload.serial}</Title>
        //         <TimerTitle auctionEndingAt={auctionEndingAt[item.payload.serial]} />
        //     </div>
        //     <div style={{marginTop: 6}}>
        //         <Subtitle>{item.title}</Subtitle>
        //     </div>
        // </div>
      );
  };

  const cards = Object.keys(glips).map((item, index) => (
    <Card key={`card-${index}`} item={glips[item]} />
  ));


  const FlexCard = ({ item }) => {
    console.log(item);
      return (        
        <Box>
            <BoxInner>                    
                <Title>{item.message}</Title>
                <StreamImageComponent
                    powerType={item.type}
                >
                </StreamImageComponent>
                {item.user_message && <Title>User Message:<br></br>{item.user_message}</Title>}
                <Subtitle style={{marginTop: 10}}>!glip IN CHAT</Subtitle>
            </BoxInner>
        </Box>        
      );
  }

  const flexCards = showText.map((item, index) => (
    <FlexCard key={`flex-card-${index}`} item={item} />
  ));

  const videos = overlayData.map((item, index) => {
    return (
      <video key={`video-players-${index}`} src={`${item.videoUri}`} id={`playVideo-${item.data.type}`} preload="auto" style={{visibility: 'hidden', width: '100vw', height: '100vh', position: 'absolute', top: 0}}></video>
    );
  })

  const messageCards = messages.map((item, index) => (
    <TimedMessage key={`timed-message-card-${index}`} item={item} message={item.message} timestamp={item.timestamp} username={item.username}/>
  ));

  

  return (
    <>
      <Mobile>
        {/* {cards} */}
        {/* {playVideoFlash && <video poster="https://via.placeholder.com/1x1" style={{width: '100vw', height: '100vh'}} autoPlay onEnded={() => setPlayVideoFlash(false)} src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/Flash_Final.webm'} />}
        {playVideoTomatoes && <video poster="https://via.placeholder.com/1x1" style={{width: '100vw', height: '100vh'}} autoPlay onEnded={() => setPlayVideoTomatoes(false)} src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/Tomatoes.webm'} />}
        {playVideoHearts && <video poster="https://via.placeholder.com/1x1" style={{width: '100vw', height: '100vh'}} autoPlay onEnded={() => setPlayVideoHearts(false)} src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/Hearts.webm'} />}
        {playVideoShit && <video poster="https://via.placeholder.com/1x1" style={{width: '100vw', height: '100vh'}} autoPlay onEnded={() => setPlayVideoShit(false)} src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/Stinky+Turds.webm'} />}
        {playVideoRShit && <video poster="https://via.placeholder.com/1x1" style={{width: '100vw', height: '100vh'}} autoPlay onEnded={() => setPlayVideoRShit(false)} src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/Rainbow+Turds.webm'} />}
        {playVideoRoses && <video poster="https://via.placeholder.com/1x1" style={{width: '100vw', height: '100vh'}} autoPlay onEnded={() => setPlayVideoRoses(false)} src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/Roses.webm'} />}
      */}
        {/* <Box>
          <BoxInner>
            <div
              style={{
                marginBottom: 18,
                display: "flex",
                justifyContent: "center",
                padding: 4,
                background: "rgba(0,0,0,0.3)",
              }}
            >
              <Text>NFT #132 · </Text>
              <TimerTitle auctionEndingAt={new Date().getTime()} />
            </div>
            <Title style={{ fontSize: 36 }}>lightningthunder</Title>
            <Bidder style={{ marginTop: 10 }}>BID 80$</Bidder>
            <Subtitle style={{ marginTop: 10 }}>!glip IN CHAT</Subtitle>
          </BoxInner>
        </Box> */}
      </Mobile>
      <Desktop
        style={{ height: "100vh", justifyContent: "center" }}
      >
        <div style={{paddingLeft: 50}}>
          {flexCards}
        </div>

        <div style={{position: 'absolute', top: 40, left: 40, display: 'flex', flexDirection: 'column'}}>
          {messageCards}
        </div>     
        <br></br>
        {/* <Box>
                    <BoxInner>
                        <div style={{marginBottom: 18, display: 'flex', justifyContent: 'center', padding: 4, background: 'rgba(0,0,0,0.3)'}}>
                            <Text>NFT #132 · </Text>
                            <TimerTitle auctionEndingAt={new Date().getTime()} />
                        </div>      
                        <Title>LIVE NFT DROPPED</Title>
                        <Subtitle style={{marginTop: 10}}>!glip IN CHAT</Subtitle>
                    </BoxInner>
                </Box> */}
        {/* <Box>
          <BoxInner>
            <div
              style={{
                marginBottom: 18,
                display: "flex",
                justifyContent: "center",
                padding: 4,
                background: "rgba(0,0,0,0.3)",
              }}
            >
              <Text>NFT #132 · </Text>
              <TimerTitle auctionEndingAt={new Date().getTime()} />
            </div>
            <Title style={{ fontSize: 36 }}>lightningthunder</Title>
            <Bidder style={{ marginTop: 10 }}>BID 80$</Bidder>
            <Subtitle style={{ marginTop: 10 }}>!glip IN CHAT</Subtitle>
          </BoxInner>
        </Box> */}
        {/* <Box winner={true}>
                    <BoxInner winner={true}>
                        <div style={{width: '100%', background: '#413321', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', padding: 10}}>
                            <div style={{marginBottom: 18, display: 'flex', justifyContent: 'center', padding: 4, background: 'rgba(0,0,0,0.3)'}}>
                                <Text>#123 · AUCTION ENDED</Text>
                            </div>      
                            <Title style={{fontSize: 21}}>@zkartmasala</Title>
                            <Bidder style={{marginTop: 10}}>WON THE NFT</Bidder>
                            <Subtitle style={{marginTop: 10}}>!glip IN CHAT</Subtitle>
                        </div>

                    </BoxInner>
                </Box> */}
        {showMessage && (
          <PurpleBox>
            <PurpleBoxInner>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  padding: 10,
                }}
              >
                <img style={{ width: 55, marginBottom: 10 }} src={social} />
                <Title style={{ fontSize: 21 }}>
                  @{messageData.user.social.twitch}
                </Title>
                <Subtitle
                  style={{
                    marginTop: 5,
                    fontSize: 10,
                    paddingBottom: 10,
                    borderBottom: "1px solid rgba(255,255,255,.1)",
                  }}
                >
                  #{messageData.serial} NFT OWNER
                </Subtitle>
                <Message style={{ marginTop: 10 }}>
                  {messageData.message}
                </Message>
              </div>
            </PurpleBoxInner>
          </PurpleBox>
        )}

        {/* <video id='playVideoFlash' preload="auto" poster="https://via.placeholder.com/1x1" style={{visibility: playVideoFlash ? 'visible' : 'hidden', width: '100vw', height: '100vh', position: 'absolute', top: 0}}  onEnded={() => {setPlayVideoFlash(false); }} src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/Flash_Final.webm'} />
        <video id='playVideoTomatoes' preload="auto" poster="https://via.placeholder.com/1x1" style={{visibility: playVideoTomatoes ? 'visible' : 'hidden', width: '100vw', height: '100vh', position: 'absolute', top: 0}}  onEnded={() => {setPlayVideoTomatoes(false);}} src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/Tomatoes.webm'} />
        <video id='playVideoHearts' preload="auto" poster="https://via.placeholder.com/1x1" style={{visibility: playVideoHearts ? 'visible' : 'hidden', width: '100vw', height: '100vh', position: 'absolute', top: 0}}  onEnded={() => {setPlayVideoHearts(false); }} src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/Hearts.webm'} />
        <video id='playVideoShit' preload="auto" poster="https://via.placeholder.com/1x1" style={{visibility: playVideoShit ? 'visible' : 'hidden', width: '100vw', height: '100vh', position: 'absolute', top: 0}}  onEnded={() => {setPlayVideoShit(false);}} src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/Stinky+Turds.webm'} />
        <video id='playVideoRShit' preload="auto" poster="https://via.placeholder.com/1x1" style={{visibility: playVideoRShit ? 'visible' : 'hidden', width: '100vw', height: '100vh', position: 'absolute', top: 0}}  onEnded={() => {setPlayVideoRShit(false); }} src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/Rainbow+Turds.webm'} />
        <video id='playVideoRoses' preload="auto" poster="https://via.placeholder.com/1x1" style={{visibility: playVideoRoses ? 'visible' : 'hidden', width: '100vw', height: '100vh', position: 'absolute', top: 0}}  onEnded={() => {setPlayVideoRoses(false); }} src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/Roses.webm'} /> */}
        {videos}
        <div id="parentnode"></div>

        <span style={{ fontSize: 32, fontWeight: 'bold', color: 'grey', display: showText ? 'block': 'none', position: 'absolute', bottom: 60, textAlign: 'center', width: '100%'}}>
          {overlayText}
        </span>


        {showTicker && <div className="ticker-wrap">
          <div className="ticker">
            <div className="ticker__item">Support me by buying my Stream Powers @ www.glip.gg/store/{username}</div>            
          </div>
        </div>}
    </Desktop>
    </>
  );
}



function TimedMessage(props) {
  const [timestamp, setTimestamp] = useState(props.timestamp);
  const [timer, setTimer] = useState(timestamp.getSeconds() + 120 - new Date().getSeconds());
  // const [ticker, setTicker] = useState();

  useEffect(() => {
    setTimeout(() => {
      if(timer > 0) {
        const now = new Date();
        const timer = timestamp.getSeconds() + 120 - now.getSeconds();
        setTimer(timer)
      }      
    }, 1000);
  }, [timer]);


  if(timer > 0 && props.message && props.message != '') {
    return (
      <>
        <span style={{margin: 4, borderRadius: 12, padding: '6px 12px', background: 'rgba(0,0,0,0.4)', color: '#fff'}}><b>{props.username}</b>: {props.message}</span>  
      </>
    );
  } else {
    return (<></>);
  }
}
